import React, { SVGProps } from 'react'
const SvgAttachmentFile = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-cta)'} fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M15.234 3.5H7A1.5 1.5 0 0 0 5.5 5v14.125a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5V7.097l-.008-.09a.5.5 0 0 0-.492-.41h-2.267V4a.5.5 0 0 0-.5-.5Zm-.501 1v2.597l.009.09a.5.5 0 0 0 .492.41H17.5v11.528a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h7.733Z"
      />
      <path
        fillRule="nonzero"
        d="M10.467 7.877a.5.5 0 0 1 .09.992l-.09.008h-2a.5.5 0 0 1-.09-.992l.09-.008h2ZM14.467 10.69a.5.5 0 0 1 .09.992l-.09.008h-6a.5.5 0 0 1-.09-.992l.09-.008h6ZM15.467 12.69a.5.5 0 0 1 .09.992l-.09.008h-7a.5.5 0 0 1-.09-.992l.09-.008h7ZM12.467 14.69a.5.5 0 0 1 .09.992l-.09.008h-4a.5.5 0 0 1-.09-.992l.09-.008h4ZM14.467 16.69a.5.5 0 0 1 .09.992l-.09.008h-6a.5.5 0 0 1-.09-.992l.09-.008h6Z"
      />
      <path d="M15.234 4 18 7.097h-2.766z" />
      <path
        fillRule="nonzero"
        d="M14.734 4v3.097a.5.5 0 0 0 .5.5H18a.5.5 0 0 0 .373-.833l-2.766-3.097a.5.5 0 0 0-.873.333Zm.999 1.31 1.15 1.287h-1.15V5.31Z"
      />
    </g>
  </svg>
)
export default SvgAttachmentFile
